import { useMutation } from 'react-query';

import getLoginMethodsV2 from '@/src/services/auth/getLoginMethodsV2';

export function useLoginMethods() {
  return useMutation(getLoginMethodsV2);
}
